export type Addresses = {
  [chainId: string]: Contracts;
};

export type Contracts = Partial<{
  [contractName in ContractName]: string;
}>;

export enum ContractName {
  SwapperRouter = "SwapperRouter",
  FeeCollector = "FeeCollector",
  SwapperTransferProxy = "SwapperTransferProxy",
  Lido = "Lido",
}
